import { Component, Input } from '@angular/core';
import {
  ActionData,
  CompanyData,
  ContractorCompanyData,
  ContractorData,
  Energy,
  kpiData,
  Personal,
  Process,
  Waste,
  ObsTypeData,
  ActionPriority,
  ManHourCalculation,
  HeadCount
} from '../../model/performance.model';

@Component({
  selector: 'ara-performance-data',
  templateUrl: './performance-data.component.html',
  styleUrls: ['./performance-data.component.css'],
})
export class PerformanceDataComponent {
  @Input() moduleValue: string = '';
  @Input() data: any;
  @Input() selectedUnit: any;
  @Input() year: any;
  @Input() MonthRange: any;
  @Input() isRefresh:any;

  personalData: Personal[] = [];
  processData: Process[] = [];
  IncidentTypeData:any[] = [];
  kpiData:kpiData[]=[];
  ActionData: ActionData[];
  contractorData: ContractorData[];
  companyData: CompanyData[];
  safetyContractorCompanyData: ContractorCompanyData;
  wasteData: Waste[];
  energyData: Energy[];
  leaderChartComp: any[] = [];
  leaderChartYTD: any[] = [];
  ObsTypeData: ObsTypeData[];
  ActionPriorityData: ActionPriority[];
  ManHourCalculation: ManHourCalculation[];
  HeadCountData: HeadCount[];
  InspectionTypeData:any[] = [];
  ObservationCategoryData:any[] = [];
  IncidentCategoryData:any[] = [];
  TrainingStatusData:any[] = [];
  TrainingComplianceData:any[] = [];
  IncidentRegisterData:any[] = [];
  EnergyWasteConsumptionData:any[] = [];
  EnergyWasteConsumptionUnitWiseData:any[] = [];
  POBRosterData:any[] = [];
  TrainingComplianceSummaryData:any[] = [];
  POBRosterMonthwiseData:any[] = [];

  constructor() {

    this.ActionData = [];

    this.safetyContractorCompanyData = {
      contractorData: this.contractorData,
      companyData: this.companyData,
    };

    this.energyData = [];
  }
}
